import React, { useRef } from "react";
import { Menu } from "primereact/menu";

import useCensus from "../../hooks/useCensus";
import useActionMenuServices from "../../hooks/useActionMenuServices";

import {UnoccupiedBed} from '../../constants/ProIcons'
import _ from 'lodash'

const ProCensusBedWithActionMenu = ({node, performAction, isEmpty= false})=>{
    const {data:{filter}} = useCensus({ refreshTree: false })   
    const {actions:{GetCensusMenuItems}} = useActionMenuServices({performAction})
    const menuRef = useRef(null)
    const iconFontSize = 15;

    var data = _.get(node.data, "assignments")?_.filter(node.data.assignments, (a)=> a.latestAssignment): null;
    var activeAssignment = _.gt(_.get(data, "length"), 0)?data[0] : null

    if(isEmpty){
        return( 
            <>
            <i className ="fas" aria-hidden="true" style={{ color: '#579800', fontSize: iconFontSize, cursor:'pointer' }}  onClick={(event) => menuRef && menuRef.current.toggle(event)}>   
                <div className='icon-display'>
                    <div><UnoccupiedBed/> </div>            
                    <span className='tree-node-svg-unoccupied'>{node.data.name}
                        {!_.get(node, "active") && <span className='tree-node-inactive'> - Inactive</span> }                      
                    </span>
                    <Menu  model={GetCensusMenuItems(activeAssignment, filter)} popup ref={menuRef} />
                </div> 
            </i>    
            </>
        )
    }else{
        return(
            <>
                <i className ="fas fa-bed" aria-hidden="true" style={{ color: '#579800', fontSize: iconFontSize, cursor:'pointer' }}  onClick={(event) => menuRef && menuRef.current.toggle(event)}>               
                    <span className='tree-node'>{node.label}
                    {!_.get(node, "active") && <span  className='tree-node-inactive'> - Inactive</span> }</span>
                    <Menu  model={GetCensusMenuItems(activeAssignment, filter)} popup ref={menuRef} />
                </i>  
            </>
        )
    }

}

export default ProCensusBedWithActionMenu;